import { Box, Button, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

export function ChatErrorBubble({ text, onRetry, retrying, disabled }: { text: string; onRetry: () => void; retrying: boolean; disabled: boolean }) {
  return (
    <Box data-testid="chat-message" data-role="assistant" data-status="error" sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1.5 }}>
      <Box role="alert" sx={{ maxWidth: '85%', px: 1.5, py: 1, borderRadius: 2, bgcolor: '#fdf1f0', border: '1px solid #f3c7c2', display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <ErrorOutlineIcon fontSize="small" sx={{ color: '#b3261e' }} />
        <Typography variant="body2" sx={{ color: '#7a1d17' }}>
          {text}
        </Typography>
        <Button size="small" startIcon={<RefreshIcon />} onClick={onRetry} disabled={disabled || retrying} sx={{ ml: 'auto' }}>
          {retrying ? 'Retrying…' : 'Retry'}
        </Button>
      </Box>
    </Box>
  );
}
